var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['message-input-editor-container', _vm.isPC && !_vm.props.shouldShowToolbar && 'message-input-editor-container-no-inputTool', _vm.isH5 && 'message-input-editor-container-h5', _vm.isH5 && !_vm.props.shouldShowEmoji && _vm.props.shouldShowToolbar && 'message-input-editor-container-h5-no-emoji-no-tool', _vm.isH5 && !_vm.props.shouldShowEmoji && !_vm.props.shouldShowToolbar && 'message-input-editor-container-h5-no-emoji', _vm.isH5 && _vm.props.shouldShowAudio && 'message-input-editor-container-h5-audio', _vm.isH5 && _vm.isInAudioMode && 'message-input-editor-container-h5-audio-mode']
  }, [_vm.isMuted ? _c('div', {
    staticClass: "message-input-mute"
  }, [_vm._v(" " + _vm._s(_vm.muteText) + " ")]) : _vm._e(), _vm.isInAudioMode ? _c('div', {
    staticClass: "audio-mode no-copy",
    on: {
      "touchstart": _vm.startRecording,
      "touchend": _vm.stopRecording,
      "touchcancel": _vm.stopRecording,
      "touchmove": _vm.handleTouchMove,
      "contextmenu": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.TUITranslateService.t('TUIChat.按住说话')) + " "), _vm.isRecording ? _c('div', {
    staticClass: "record-container"
  }, [_c('div', {
    staticClass: "record-tip"
  }, [_vm._v(" " + _vm._s(_vm.recordTip) + " ")]), _c('div', {
    staticClass: "audio-wave-container"
  }, [_c('div', {
    class: ['audio-wave-bubble', _vm.recordCancel ? 'audio-wave-bubble-cancel' : '']
  }, [_c('div', {
    staticClass: "audio-wave"
  }, _vm._l(_vm.audioWaveBars, function (bar, index) {
    return _c('div', {
      key: index,
      staticClass: "wave-bar",
      style: {
        height: bar.height + 'px'
      }
    });
  }), 0)])])]) : _vm._e()]) : _vm._e(), !_vm.isMuted && _vm.enableInput && !_vm.isInAudioMode ? _c('div', {
    ref: "editorDom",
    staticClass: "message-input-editor-area",
    attrs: {
      "contenteditable": _vm.isH5
    },
    on: {
      "keydown": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleEnter.apply(null, arguments);
      },
      "drop": _vm.handlePCFileDrop,
      "paste": _vm.handlePaste,
      "input": _vm.handleH5Input,
      "blur": _vm.handleH5Blur,
      "focus": _vm.handleH5Focus
    }
  }) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }